import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientDetailLayoutSkeleton } from '@/feature/hotline/client/detail/component/HotlineClientDetailLayout';
import { HotlineClientNegotiateContentSkeleton } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientNegotiateContent';
import { HotlineClientNegotiateListSkeleton } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientNegotiateList';
import { hotlineClientDetailNegotiateViewStyle } from '@/feature/hotline/client/detail/negotiate/page/style';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/**
 * 匿名コンサルホットライン クライアント 相談画面（スケルトン表示）
 */
export const HotlineClientDetailNegotiateViewSkeleton = () => {
    const dummies = useArrayWithIndex(4);
    const style = hotlineClientDetailNegotiateViewStyle();
    return (_jsx(HotlineClientDetailLayoutSkeleton, Object.assign({ activeStepIndex: 1, classNames: { childrenWrap: style.base() } }, { children: _jsx(HotlineClientNegotiateListSkeleton, Object.assign({ dummies: dummies }, { children: dummies.map(({ index: key }, index) => (_jsx(HotlineClientNegotiateContentSkeleton, { displayContent: index === 0 }, key))) })) })));
};
